import { Component } from "@angular/core";
import {
  IonicPage,
  LoadingController,
  NavController,
  NavParams,
} from "ionic-angular";
import { ServiceProvider } from "../../providers/service/service";
import { TranslateService } from "@ngx-translate/core";
import { Http, RequestOptions, Headers } from "@angular/http";
import { SelectSearchableComponent } from "ionic-select-searchable";
import { Storage } from "@ionic/storage";
import { MerchantHomePage } from "../merchant-home/merchant-home";
import { ViewHeaderPage } from "../view-header/view-header";
import { HomePage } from "../home/home";

/**
 * Generated class for the DiscountListPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */
class Discount {
  public id: number;
  public name: string;
}

@IonicPage()
@Component({
  selector: "page-discount-list",
  templateUrl: "discount-list.html",
})
export class DiscountListPage {
  code: string = "";
  discounts: Discount[];
  discount: Discount;
  discountVal: number | null = null;
  theme = 1;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private storage: Storage,
    private services: ServiceProvider,
    private http: Http,
    private translateService: TranslateService,
    private loadingCtrl: LoadingController
  ) {}

  async ionViewDidLoad() {
    this.theme = await this.storage.get("theme");

    const loader = this.loadingCtrl.create({
      content: "Loading...",
    });
    loader.present();

    this.storage.get("token").then((token) => {
      var link2 = this.services.URLDiscount;
      var headers = new Headers();
      headers.append("Accept", "application/json");
      headers.append("Authorization", "Bearer " + token);
      const requestOptions = new RequestOptions({ headers: headers });

      this.http
        .get(link2, requestOptions)
        .map((res) => res.json())
        .subscribe(
          (data) => {
            this.discounts = data;
            loader.dismiss();
          },
          (error) => {
            var response = JSON.parse(error._body);
            this.translateService.get(response.message).subscribe((value) => {
              this.services.presentToast(value);
            });
            loader.dismiss();
          }
        );
    });
  }

  /** getCode for new function ##เช่าพื้นที่ 1 */
  getCode() {
    // this.code = "X2FGJ4";
    const loader = this.loadingCtrl.create({
      content: "Loading...",
    });

    loader.present();

    this.storage.get("info").then((info) => {
      this.storage.get("token").then((token) => {
        var link =
          info.role == 1
            ? this.services.URLPlazaDiscountCode
            : this.services.URLMerchantDiscountCode;
        var headers = new Headers();
        headers.append("Accept", "application/json");
        headers.append("Authorization", "Bearer " + token);
        const requestOptions = new RequestOptions({ headers: headers });

        this.http
          .post(
            link,
            {
              discount: this.discountVal,
            },
            requestOptions
          )
          .map((res) => res.json())
          .subscribe(
            (data) => {
              this.code = data.code;
              loader.dismiss();
            },
            (error) => {
              var response = JSON.parse(error._body);

              this.translateService.get(response.message).subscribe((value) => {
                this.services.presentToast(value);
              });
              loader.dismiss();
            }
          );
      });
    });
  }

  copyToClipboard = (): boolean => {
    const el = document.createElement("textarea");
    el.value = this.code;
    el.setAttribute("readonly", "");
    // el.style = { position: "absolute", left: "-9999px" };
    document.body.appendChild(el);

    el.select();
    // Copy text to clipboard
    try {
      const successful = document.execCommand("copy");
      if (successful) {
        document.body.removeChild(el);
        // copy to clipboard
        this.services.presentToast("copied!");
        return true;
      }
    } catch (err) {
      return false;
    }

    return false;
  };

  discountChange(event: { component: SelectSearchableComponent; value: any }) {
    this.code = "";
    this.discountVal = event.value.discount_id;
  }

  backPage() {
    this.navCtrl.pop();
  }

  openHeadPage() {
    this.navCtrl.push(ViewHeaderPage);
  }

  homePage() {
    this.storage.get("info").then((info) => {
      console.log(info.role);

      this.navCtrl.push(info.role == 2 ? MerchantHomePage : HomePage);
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/discount-list/discount-list.ts